import React from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { FaLinkedin, FaFacebook, FaWhatsapp, FaTwitter, FaYoutube } from 'react-icons/fa';

export default function Contact() {
  const openSocial = (e, url) => {
    if (typeof window !== 'undefined' && window.innerWidth > 800) {
      e.preventDefault();
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_d6ed78a',    // from EmailJS dashboard
      'template_ywsddeg',   // from EmailJS template
      e.target,
      'A9TtfQEU-lqJ7ST31'     // from EmailJS dashboard
    )
    .then(() => {
      alert('Message sent successfully!');
      e.target.reset();
    })
    .catch(() => {
      alert('Failed to send message. Please try again.');
    });
  };

  return (
    <section id="contact" className="comp-section contact" aria-labelledby="contact-heading">
      <div className="contact-head">
        <h2 id="contact-heading">Contact Us</h2>
        <p className="muted">Reach out to discuss your project or request a proposal.</p>
      </div>

      <div className="contact-grid">
        <aside className="contact-info" aria-label="Contact information">
          <div className="info-card">
            <div className="info-methods">
              <a className="method" href="mailto:sijutech.bd@gmail.com">
                <FiMail className="icon" aria-hidden="true" />
                <div className="meta">
                  <div className="label">Email</div>
                  <div className="value">auroratech.bd@gmail.com</div>
                </div>
              </a>

              <a className="method" href="tel:+8801776679697">
                <FiPhone className="icon" aria-hidden="true" />
                <div className="meta">
                  <div className="label">Phone</div>
                  <div className="value">+880 1776 679697</div>
                </div>
              </a>

              <div className="method location">
                <FiMapPin className="icon" aria-hidden="true" />
                <div className="meta">
                  <div className="label">Office</div>
                  <div className="value">2/2, Bolashpur, Mymensingh, Bangladesh</div>
                </div>
              </div>
            </div>

            <div className="info-footer">
              <div className="social-inline">
                <a className="social-link" href="https://www.linkedin.com/company/siju-tech/" aria-label="LinkedIn" onClick={(e) => openSocial(e, 'https://www.linkedin.com/company/siju-tech/')}>
                  <FaLinkedin className="icon" aria-hidden="true" />
                  <span className="social-label">LinkedIn</span>
                </a>
                <a className="social-link" href="https://www.facebook.com/people/SiJu-Tech/61579698222166/" aria-label="Facebook" onClick={(e) => openSocial(e, 'https://www.facebook.com/people/SiJu-Tech/61579698222166/')}>
                  <FaFacebook className="icon" aria-hidden="true" />
                  <span className="social-label">Facebook</span>
                </a>
                <a className="social-link" href="https://wa.me/message/RFY36YIFX6CQK1" aria-label="WhatsApp" onClick={(e) => openSocial(e, 'https://wa.me/message/RFY36YIFX6CQK1')}>
                  <FaWhatsapp className="icon" aria-hidden="true" />
                  <span className="social-label">WhatsApp</span>
                </a>
                <a className="social-link" href="https://x.com/SijuTech61685" aria-label="X" onClick={(e) => openSocial(e, 'https://x.com/SijuTech61685')}>
                  <FaTwitter className="icon" aria-hidden="true" />
                  <span className="social-label">X</span>
                </a>
                <a className="social-link" href="https://www.youtube.com/@sijutech1" aria-label="YouTube" onClick={(e) => openSocial(e, 'https://www.youtube.com/@sijutech1')}>
                  <FaYoutube className="icon" aria-hidden="true" />
                  <span className="social-label">YouTube</span>
                </a>
              </div>
            </div>
          </div>
        </aside>

        <form className="contact-form" onSubmit={sendEmail} aria-label="Contact form">
          <input name="name" placeholder="Name" required />
          <input name="email" placeholder="Email" type="email" required />
          <input name="subject" placeholder="Subject" />
          <textarea name="message" placeholder="Brief message" rows="6" required />
          <div className="form-actions">
            <button className="btn primary" type="submit">Send message</button>
          </div>
        </form>
      </div>
    </section>
  );
}
